import { BaseRequest } from './BaseRequest';

export class AccountRequest extends BaseRequest {
    AccountIdentity : string | null;
    
    constructor(accountIdentity: string, clusterName: string) {
      super();
      this.AccountIdentity = accountIdentity;
      this.ClusterName = clusterName;
    }
}